import {useAuthState} from "react-firebase-hooks/auth";
import {auth} from "../firebase/index.js";
import APXWebApp from "./APXWebApp.jsx";


export default function Dashboard() {
	  
	  const [user, loading, error] = useAuthState(auth);
 
 	  return (
				 <>
						
						{user === null ?
								  null
								  :
								  <>
										 {/* {<Typography variant="h6">Dashboard</Typography>} */}
										 <APXWebApp/>
								  </>
						}
				 
				 </>
	  );
}